import { EBlotterTab } from '../enums';
import { enumTransformer } from './object-utils';
import { IOrderStatus, PendingStrategy } from '../interfaces';
import { SpotType } from '@fnx/fx-pad';

export const orderStatusMapper: Record<IOrderStatus, string> = {
    unknown: 'Unknown',
    executing: 'Executing',
    active: 'Active',
    filled: 'Filled',
    partiallyFilled: 'Partially Filled',
    partiallyCancelled: 'Partially Cancelled',
    cancelled: 'Cancelled',
    rejected: 'Rejected',
    inactive: 'Inactive',
    suspended: 'Suspended',
};

export const spotTypeToTextMapper: Record<SpotType, string> = {
    market: 'MKT',
    full: 'Full',
    ioc: 'IOC',
    limit: 'Limit',
    stop: 'Stop',
    oco: 'OCO',
    ifDone: 'If Done',
};

export const pendingStrategyMapper: Record<PendingStrategy, string> = {
    singleOrder: 'Single Order',
    oco: 'OCO',
    ifDone: 'If Done',
};

const tabHeaderMapper = new Map<EBlotterTab, string>([
    [ 'spot', 'Spot' ],
    [ 'forward', 'Forward & FX Swap' ],
    [ 'pending', 'Pending' ],
    [ 'kondor', 'Kondor' ],
    [ 'position', 'FX Position' ],
]);

export const getTabName: (value: EBlotterTab) => string =
    enumTransformer('blotter type', tabHeaderMapper);
